<template>
  <div class="appointment-type">
    <div class="heading-appoitment emt-6">Notes</div>
    <div class="content-wrapper notes-block">
      <div class="input-wrapper position-relative first notes-area">
        <div>
          <div
            id="notes"
            rows="6"
            @input="setNotesLocal"
            class="textarea-appoitment edit-notes"
            contenteditable="true"
            ref="editableDiv"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapGetters } from "vuex";
import { notesMixin } from "../../../mixins/notesMixin";

export default {
  methods: {
    ...mapMutations("addNew", {
      setNotes: "setNotes"
    }),
    setNotesLocal() {
      this.setNotes(this.$refs.editableDiv.innerHTML);
    }
  },
  computed: {
    ...mapGetters("addNew", {
      notes: "getNotes"
    })
  },
  mixins: [notesMixin]
};
</script>

<style scoped>
/* CSS HERE */
#notes {
  width: auto!important;
  min-height: 100px;
  border: 1px solid #ddd;
  border-radius: 5px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  margin:10px 15px 0 15px!important;
}
.content-wrapper.notes-block{
  width:100%!important;
}
.notes-area{
  width:100%!important;
  padding-left:0!important;
}

.input-wrapper {
  margin-bottom: 78px;
}

</style>
